var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;

  for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];

  return r;
};

import { audioParamProperties, constructorParamsKeys, setters, startAndStopNodes } from '../data';
import { capitalize, equals, find, values } from '../utils';
import CustomVirtualAudioNode from './CustomVirtualAudioNode';

var createAudioNode = function (audioContext, name, audioNodeFactoryParam) {
  var audioNodeFactoryName = "create" + capitalize(name);

  if (typeof audioContext[audioNodeFactoryName] !== 'function') {
    throw new Error("Unknown node type: " + name);
  }

  var audioNode = audioNodeFactoryParam ? audioContext[audioNodeFactoryName](audioNodeFactoryParam) : audioContext[audioNodeFactoryName]();
  return audioNode;
};

var StandardVirtualAudioNode =
/** @class */
function () {
  function StandardVirtualAudioNode(node, output, params, input) {
    this.node = node;
    this.output = output;
    this.params = params;
    this.input = input;
    this.connected = false;
    this.connections = [];
    var stopTime = params && params.stopTime;
    this.stopCalled = stopTime !== undefined;
  }

  StandardVirtualAudioNode.prototype.connect = function () {
    var connectArgs = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      connectArgs[_i] = arguments[_i];
    }

    var audioNode = this.audioNode;
    var filteredConnectArgs = connectArgs.filter(Boolean);
    var firstArg = filteredConnectArgs[0],
        rest = filteredConnectArgs.slice(1);

    if (audioNode.connect) {
      audioNode.connect.apply(audioNode, __spreadArrays([firstArg], rest));
    }

    this.connections = this.connections.concat(filteredConnectArgs);
    this.connected = true;
  };

  StandardVirtualAudioNode.prototype.disconnect = function (node) {
    var audioNode = this.audioNode;

    if (node) {
      if (node instanceof CustomVirtualAudioNode) {
        var _loop_1 = function (childNode) {
          if (!this_1.connections.some(function (x) {
            return x === childNode.audioNode;
          })) return "continue";
          this_1.connections = this_1.connections.filter(function (x) {
            return x !== childNode.audioNode;
          });
        };

        var this_1 = this;

        for (var _i = 0, _a = values(node.virtualNodes); _i < _a.length; _i++) {
          var childNode = _a[_i];

          _loop_1(childNode);
        }
      } else {
        if (!this.connections.some(function (x) {
          return x === node.audioNode;
        })) return;
        this.connections = this.connections.filter(function (x) {
          return x !== node.audioNode;
        });
      }
    }

    if (audioNode.disconnect) audioNode.disconnect();
    this.connected = false;
  };

  StandardVirtualAudioNode.prototype.disconnectAndDestroy = function () {
    var _a = this,
        audioNode = _a.audioNode,
        stopCalled = _a.stopCalled;

    if (audioNode.stop && !stopCalled) {
      ;
      audioNode.stop();
    }

    if (audioNode.disconnect) audioNode.disconnect();
    this.connected = false;
  };

  StandardVirtualAudioNode.prototype.initialize = function (audioContext) {
    var params = this.params || {};
    var constructorParam = params[find(function (key) {
      return constructorParamsKeys.indexOf(key) !== -1;
    }, Object.keys(params))];
    var offsetTime = params.offsetTime,
        startTime = params.startTime,
        stopTime = params.stopTime; // TODO remove `any` when AudioScheduledSourceNode typings are correct

    var audioNode = createAudioNode(audioContext, this.node, constructorParam);
    this.audioNode = audioNode;
    this.params = undefined;
    this.update(params);

    if (startAndStopNodes.indexOf(this.node) !== -1) {
      audioNode.start(startTime == null ? audioContext.currentTime : startTime, offsetTime || 0);
      if (stopTime != null) audioNode.stop(stopTime);
    }

    return this;
  };

  StandardVirtualAudioNode.prototype.update = function (params) {
    if (params === void 0) {
      params = {};
    }

    var audioNode = this.audioNode;

    var _loop_2 = function (key) {
      if (constructorParamsKeys.indexOf(key) !== -1) return "continue";
      var param = params[key];
      if (this_2.params && equals(this_2.params[key], param)) return "continue";

      if (audioParamProperties.indexOf(key) !== -1) {
        if (Array.isArray(param)) {
          if (this_2.params) audioNode[key].cancelScheduledValues(0);

          var callMethod = function (_a) {
            var _b;

            var methodName = _a[0],
                args = _a.slice(1);

            return (_b = audioNode[key])[methodName].apply(_b, args);
          };

          Array.isArray(param[0]) ? param.forEach(callMethod) : callMethod(param);
          return "continue";
        }

        audioNode[key].value = param;
        return "continue";
      }

      if (setters.indexOf(key) !== -1) {
        audioNode["set" + capitalize(key)].apply(audioNode, param);
        return "continue";
      }

      audioNode[key] = param;
    };

    var this_2 = this;

    for (var _i = 0, _a = Object.keys(params); _i < _a.length; _i++) {
      var key = _a[_i];

      _loop_2(key);
    }

    this.params = params;
    return this;
  };

  return StandardVirtualAudioNode;
}();

export default StandardVirtualAudioNode;